import { PILL_TONES } from './caseStatus'

/**
 * CaseStatusBlock — the top of Case Home's Orella card: where the case stands and what comes next. s124 (canvas
 * "Orella Case Home — Revised" boards A–C APPROVED 2026-10-30). PRESENTATIONAL: caseStatusModel decides, CaseHome
 * translates, this draws — a status pill, "Step n of 4", one bar segment per step, and the "Next: …" headline.
 */
export default function CaseStatusBlock({ model, pillText, stepText, nextText, stepNames = [] }) {
  if (!model) return null
  const tone = PILL_TONES[model.tone] || PILL_TONES.blue
  return (
    <div data-case-status={model.pill} style={{ marginBottom: 12 }}>
      <div className="flex items-center justify-between" style={{ gap: 8 }}>
        <span className="inline-flex items-center rounded-full font-bold" data-case-status-pill=""
              style={{ gap: 6, background: tone.bg, color: tone.fg, fontSize: 12, padding: '5px 10px' }}>
          <span aria-hidden="true" className="rounded-full" style={{ width: 8, height: 8, background: tone.dot }} />
          {pillText}
        </span>
        <span className="font-semibold" style={{ fontSize: 12, color: '#475569' }}>{stepText}</span>
      </div>
      <div className="grid" style={{ gridTemplateColumns: `repeat(${Math.max(1, model.segs.length)}, minmax(0, 1fr))`, gap: 6, marginTop: 12 }}
           role="img" aria-label={stepText}>
        {model.segs.map((s, i) => (
          <div key={i} className="flex flex-col" style={{ gap: 5 }}>
            <div className="rounded-full" style={{ height: 6, background: s === 'done' ? '#46A8F9' : s === 'now' ? '#15354F' : '#E3ECF3' }} />
            <span className="truncate" style={{ fontSize: 11, fontWeight: s === 'now' ? 800 : 600, color: s === 'todo' ? '#64748B' : s === 'now' ? '#15354F' : '#475569' }}>
              {stepNames[i] || ''}
            </span>
          </div>
        ))}
      </div>
      {nextText && (
        <h2 className="m-0 font-extrabold" data-case-next="" style={{ fontSize: 19, lineHeight: 1.25, color: '#15354F', marginTop: 12 }}>{nextText}</h2>
      )}
    </div>
  )
}
